import { Divider } from 'primereact/divider';
import './Overview.css';
import Section from '../common/Section/Section';
import useDimensions from '../../hooks/useDimensions';
import { PartiesDataResponseType } from '../../types';
import { useTranslation } from 'react-i18next';
import OverviewItem from './OverviewItem';
import { capitalizeFirstLetter } from '../../utils/texts';

type Props = {
    basicData: any;
    partiesData: PartiesDataResponseType[];
};

const Overview = ({ basicData, partiesData }: Props) => {
    const { width } = useDimensions();
    const { t } = useTranslation();

    const { pocet_zastupitelu, pocet_zastupitelek, pocet_zasedani, pocet_hlasovani, koalice } = basicData;

    const activeParties = partiesData.filter((party) => party.aktivni);
    const coalitionParties = activeParties.filter((party) =>
        koalice.some(
            (coalitionParty: { strana_zkratka: string }) => coalitionParty.strana_zkratka === party.strana_zkratka
        )
    );
    const oppositionParties = activeParties.filter(
        (party) =>
            !koalice.some(
                (coalitionParty: { strana_zkratka: string }) => coalitionParty.strana_zkratka === party.strana_zkratka
            )
    );

    return (
        <>
            <Section contentClassName='overview-wrapper'>
                <div className='overview-first-row'>
                    <div className='overview-item-group'>
                        <OverviewItem
                            icon='female'
                            text={capitalizeFirstLetter(t('councilMember_1', { count: pocet_zastupitelek }))}
                            value={pocet_zastupitelek}
                        />
                        <Divider layout='vertical' />
                        <OverviewItem
                            icon='male'
                            text={capitalizeFirstLetter(t('councilMember_0', { count: pocet_zastupitelu }))}
                            value={pocet_zastupitelu}
                        />
                    </div>
                    <Divider layout={width < 1200 ? 'horizontal' : 'vertical'} />
                    <div className='overview-item-group'>
                        <OverviewItem
                            icon='event_available'
                            text={capitalizeFirstLetter(t('meetings'))}
                            value={pocet_zasedani}
                        />
                        <Divider layout='vertical' />
                        <OverviewItem
                            icon='select_check_box'
                            text={t('Votings')}
                            value={pocet_hlasovani.toLocaleString('cz')}
                        />
                    </div>
                </div>
                <Divider />
                <div className='overview-item-group'>
                    <OverviewItem icon='handshake' text={t('coalition')} value={coalitionParties} variant='list' />
                    <Divider layout='vertical' />
                    <OverviewItem
                        icon='thumbs_up_down'
                        text={t('opposition')}
                        value={oppositionParties}
                        variant='list'
                    />
                </div>
            </Section>
        </>
    );
};

export default Overview;
